export default __webpack_public_path__ + "static/BhcoeAccredidation-65fcd115219d30a95486f27482f34792.webp";